<template>
  <div>
    <Head title="Paneli" />


    <div class="flex flex-wrap items-center mb-6 lg:mb-6">

      <select-input v-model="form.orders_type"  class="pr-5 w-full lg:w-1/12" label="Dërgesat">
        <option value="active">Aktive</option>
        <option value="archived">Të arkivuara</option>
        <option value="all">Të gjitha</option>
      </select-input>

      <select-input v-model="form.area_type"  class="pr-5 w-full lg:w-1/12" label="Qytet/Fshat">
        <option :value="null">Të gjitha</option>
        <option value="qytet">Qytet</option>
        <option value="fshat">Fshat</option>
      </select-input>

      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label text-sm">Nga data:</label>
        <input v-model="form.start_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>
    </div>


    <div class="flex flex-wrap items-center mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label">Shteti:</label>
        <Multiselect
          v-model="form.country_ids"
          :options="filterCountries.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>


      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label">Qyteti:</label>
        <Multiselect
          v-model="form.city_ids"
          :options="filterCities.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label">Shoferi shpërndarës:</label>
        <Multiselect
          v-model="form.delivery_driver_ids"
          :options="filterDeliveryDrivers.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <button class="mt-7 text-gray-500 hover:text-gray-700 focus:text-indigo-500 text-sm" type="button" @click="reset">Pastro</button>
      </div>
    </div>

    <div  class="flex flex-wrap mx-2 mb-6 lg:mb-6">
      <h3 class="text-sm font-bold pr-6 w-full lg:w-full">Dërgesa
        <hr></h3>


      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(1)">{{this.ordersData.created}}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të regjistruara</h1>
      </div>
      <loading-ticket v-else></loading-ticket>



      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5  mr-5 mt-2  w-full lg:w-1/6 bg-indigo-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(2)">{{ this.ordersData.processing }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në proces</h1>
      </div>
      <loading-ticket v-else></loading-ticket>


      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-orange-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(3)">{{ this.ordersData.warehouse }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në depo</h1>
      </div>
      <loading-ticket v-else></loading-ticket>


      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-indigo-900 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(4)">{{ this.ordersData.shipping }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në shpërndarje</h1>
      </div>
      <loading-ticket v-else></loading-ticket>


      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-700 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(6)">{{ this.ordersData.pending }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në pritje</h1>
      </div>
      <loading-ticket v-else></loading-ticket>



      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-green-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(5)">{{ this.ordersData.delivered }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Sukses</h1>
        <h1 class="text-sm text-white">Total shitje: {{parseFloat(this.ordersData.delivered_sales).toFixed(2)}}</h1>
        <h1 class="text-sm text-white">Total posta: {{parseFloat(this.ordersData.delivered_shipping_cost).toFixed(2)}}</h1>
        <h1 class="text-sm text-white">Total shuma NETO : {{parseFloat(netoDeliveredSales).toFixed(2) }}</h1>
      </div>
      <loading-ticket v-else></loading-ticket>


      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-red-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(7)">{{ this.ordersData.cancelled }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të anuluara</h1>
        <h1 class="text-sm text-white">Total posta: {{this.ordersData.cancelled_cancelled_cost}}</h1>
      </div>
      <loading-ticket v-else></loading-ticket>


      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-gray-400 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(8)">{{ this.ordersData.returned }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të kthyera</h1>
        <h1 class="text-sm text-white">Total posta: {{this.ordersData.returned_cancelled_cost}}</h1>
      </div>
      <loading-ticket v-else></loading-ticket>


      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2   w-full lg:w-1/6 bg-green-900 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getBarazuarOrdersUrl()">{{ this.ordersData.likujduar }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të likuiduara</h1>
        <h1 class="text-sm text-white">Total shitje: {{parseFloat(this.ordersData.likujduar_sales).toFixed(2)}}</h1>
        <h1 class="text-sm text-white">Total posta: {{parseFloat(this.ordersData.likujduar_shipping_cost).toFixed(2)}}</h1>
        <h1 class="text-sm text-white">Total shuma NETO : {{parseFloat(netoLikuiduarSales).toFixed(2) }}</h1>
      </div>
      <loading-ticket v-else></loading-ticket>
    </div>


    <div v-if="user.role === 'superadmin'" class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div v-if="this.dailyOrdersData" class="overflow-hidden rounded-md shadow bg-white w-full lg:w-1/2">
        <canvas class="bg-white" id="sucessAndCancelChart" style="min-height: 400px !important;"></canvas>
      </div>
      <div v-else class="p-10 overflow-hidden rounded-md shadow bg-white w-full lg:w-1/2 content-center">
        <div role="status" class="flex justify-center">
          <svg aria-hidden="true" class="w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-indigo-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div v-if="this.ordersByCountry" id='ordersByCountryChartContainer' class="overflow-hidden rounded-md shadow bg-white w-full lg:w-1/2">
        <canvas ref='chart' class="bg-white" id="ordersByCountryChart" height="150"></canvas>
      </div>
      <div v-else class="p-10 overflow-hidden rounded-md shadow bg-white w-full lg:w-1/2 content-center">
        <div role="status" class="flex justify-center">
          <svg aria-hidden="true" class="w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-indigo-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>




    <div  class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class="overflow-hidden w-full lg:w-1/2">

        <div class="ml-5 mb-5 mt-5 flex items-center">
          <h2 class="text-2xl font-bold">Top 15 Bizneset</h2>
        </div>

        <div v-if="this.businessesData" class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full">
            <thead>
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-2">Emri i biznesit</th>
              <th class="pb-4 pt-6 px-2">Të regjistruara</th>
              <th class="pb-4 pt-6 px-2">Në proces</th>
              <th class="pb-4 pt-6 px-2">Në depo</th>
              <th class="pb-4 pt-6 px-2">Në shpërndarje</th>
              <th class="pb-4 pt-6 px-2">Në pritje</th>
              <th class="pb-4 pt-6 px-2">Sukses</th>
              <th class="pb-4 pt-6 px-2">Të anuluara</th>
              <th class="pb-4 pt-6 px-2">Gjithsejt</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="businessData in businessesData" class="hover:bg-gray-100 focus-within:bg-gray-100">

              <td class="border-t px-2 py-2">
                {{ businessData.business_name }}
              </td>
              <td class="border-t px-2">
                {{ businessData.created }}
              </td>
              <td class="border-t px-2">
                {{ businessData.processing }}
              </td>
              <td class="border-t px-2">
                {{ businessData.warehouse }}
              </td>
              <td class="border-t px-2">
                {{ businessData.shipping }}
              </td>
              <td class="border-t px-2">
                {{ businessData.pending }}
              </td>
              <td class="border-t px-2">
                {{ businessData.delivered }}
              </td>
              <td class="border-t px-2">
                {{ businessData.cancelled }}
              </td>
              <td class="border-t px-2">
                {{ businessData.total }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="bg-white rounded-md shadow overflow-x-auto p-10">
          <div role="status">
            <svg aria-hidden="true" class="w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-indigo-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>


      <div class="overflow-hidden w-full lg:w-1/2">

        <div class="ml-5 mb-5 mt-5 flex items-center">
          <h2 class="text-2xl font-bold">Shoferët shpërndarës</h2>
        </div>

        <div v-if="this.deliveryDriversData" class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full">
            <thead>
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-2">Emri i shoferit</th>
              <th class="pb-4 pt-6 px-2">Në shpërndarje</th>
              <th class="pb-4 pt-6 px-2">Në pritje</th>
              <th class="pb-4 pt-6 px-2">Sukses</th>
              <th class="pb-4 pt-6 px-2">Të anuluara</th>
              <th class="pb-4 pt-6 px-2">Gjithsejt</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="driverData in deliveryDriversData" class="hover:bg-gray-100 focus-within:bg-gray-100">

              <td class="border-t px-2 py-2">
                {{ driverData.driver_name }}
              </td>
              <td class="border-t px-2">
                {{ driverData.shipping }}
              </td>
              <td class="border-t px-2">
                {{ driverData.pending }}
              </td>
              <td class="border-t px-2">
                {{ driverData.delivered }}
              </td>
              <td class="border-t px-2">
                {{ driverData.cancelled }}
              </td>
              <td class="border-t px-2">
                {{ driverData.total }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="bg-white rounded-md shadow overflow-x-auto p-10">
          <div role="status">
            <svg aria-hidden="true" class="w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-indigo-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>


    </div>




  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Chart from 'chart.js/auto';
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'
import Multiselect from '@vueform/multiselect'
import {computed} from 'vue'
import {Inertia} from "@inertiajs/inertia";
import LoadingTicket from '@/Shared/LoadingTicket'
import SelectInput from '@/Shared/SelectInput.vue'



export default {
  components: {
    SelectInput,
    LoadingTicket,
    Head,
    Link,
    Multiselect
  },
  layout: Layout,
  props: {
    ordersData: Object,
    businessesData: Object,
    deliveryDriversData: Object,
    dailyOrdersData: Object,
    ordersByCountry: Object,
    countries: Object,
    cities: Object,
    deliveryDrivers: Object,
    filters: Object,
  },
  mounted() {
    if(this.user.role === 'superadmin'){
      this.generateSucessAndCancelLineChart();
      this.generateOrdersByCountryBarChart()
    }
  },
  data() {
    return {
      form: {
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        country_ids: this.filters.country_ids,
        city_ids : this.filters.city_ids,
        delivery_driver_ids: this.filters.delivery_driver_ids,
        orders_type: this.filters.orders_type,
        area_type: this.filters.area_type ?? null
      },
      filterCountries: {
        options: this.countries.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterCities: {
        options: this.cities.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterDeliveryDrivers: {
        options: this.deliveryDrivers.map(function(deliveryDriver){
          return {value: deliveryDriver.id, label: deliveryDriver.name}
        }),
      },
      dailyOrderChartExist: false,
      ordersByCountryChartExists: false
    }
  },
  computed: {
    netoDeliveredSales(){
      return this.ordersData.delivered_sales - this.ordersData.delivered_shipping_cost
    },
    netoLikuiduarSales(){
      return this.ordersData.likujduar_sales - this.ordersData.likujduar_shipping_cost
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/paneli', pickBy(this.form), {
          preserveState: true,
          onSuccess: () => {
            this.updateOrdersByCountryBarChart();
            this.updateSucessAndCancelLineChart();
          }
        });

      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
    getOrdersByStatusUrl(statusId){
      let url = "/admin/dergesat?status_ids[]=" + statusId
      if(this.filters.start_date)
        url += ("&start_date_status_updated=" + this.filters.start_date)

      if(this.filters.end_date)
        url += ("&end_date_status_updated=" + this.filters.end_date)

      if(this.filters.country_ids)
        this.filters.country_ids.forEach(function(key,value){
          url += ("&country_ids[]=" + key)
        })

      if(this.filters.city_ids)
        this.filters.city_ids.forEach(function(key,value){
          url += ("&city_ids[]=" + key)
        })

      if(this.filters.delivery_driver_ids)
        this.filters.delivery_driver_ids.forEach(function(key,value){
          url += ("&delivery_driver_ids[]=" + key)
        })

      return url;
    },
    getBarazuarOrdersUrl(){
      let url = "/admin/dergesat?barazuar=true"
      if(this.filters.start_date)
        url += ("&start_date_barazuar=" + this.filters.start_date)

      if(this.filters.end_date)
        url += ("&end_date_barazuar=" + this.filters.end_date)

      if(this.filters.country_ids)
        this.filters.country_ids.forEach(function(key,value){
          url += ("&country_ids[]=" + key)
        })

      if(this.filters.city_ids)
        this.filters.city_ids.forEach(function(key,value){
          url += ("&city_ids[]=" + key)
        })

      if(this.filters.delivery_driver_ids)
        this.filters.delivery_driver_ids.forEach(function(key,value){
          url += ("&delivery_driver_ids[]=" + key)
        })

      return url;
    },
    getTodayDate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    getTomorrowDate(){
      var today = new Date();
      var dd = String(today.getDate() + 1).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    generateOrdersByCountryBarChart(){
      const ordersByCountryChart = document.getElementById('ordersByCountryChart');

        return  new Chart(ordersByCountryChart, {
          type: 'bar',
          data: {
            labels: this.ordersByCountry.map(x => x.country),
            datasets: [{
              label: 'Dërgesat',
              data: this.ordersByCountry.map(x => x.orders),
              backgroundColor: [
                'rgba(148, 163, 184, 1)',
              ],
              borderColor: [
                'rgba(239, 68, 68, 1)',
              ],
              borderWidth: 1,

            }]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });
    },
    updateOrdersByCountryBarChart(){
      const chart = Chart.getChart("ordersByCountryChart");
      chart.data.datasets[0].data = this.ordersByCountry.map(x => x.orders);
      chart.update()
    },
    generateSucessAndCancelLineChart(){
      const sucessAndCancelChart = document.getElementById('sucessAndCancelChart');

        return new Chart(sucessAndCancelChart, {
          type: 'line',
          data: {
            labels: this.dailyOrdersData.success.map(x => x.date),
            datasets: [{
              label: 'Të anuluara',
              data: this.dailyOrdersData.canceled.map(x => x.orders),
              backgroundColor: [
                'rgba(239, 68, 68, 1)',
              ],
              borderColor: [
                'rgba(239, 68, 68, 1)',
              ],
              borderWidth: 1,

            },
              {
                label: 'Sukses',
                data: this.dailyOrdersData.success.map(x => x.orders),
                backgroundColor: [
                  'rgba(34, 197, 94, 1)',
                ],
                borderColor: [
                  'rgba(34, 197, 94, 1)',
                ],
                borderWidth: 1,
                lineTension: 0.4,
              },
              {
                label: 'Të regjistruara',
                data: this.dailyOrdersData.created.map(x => x.orders),
                backgroundColor: [
                  'rgb(234,179,8,1)',
                ],
                borderColor: [
                  'rgb(234,179,8,1)',
                ],
                borderWidth: 1,
                lineTension: 0.4,
              },

            ]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });

    },
    updateSucessAndCancelLineChart(){
      const chart = Chart.getChart("sucessAndCancelChart");
      chart.data.datasets[0].data = this.dailyOrdersData.canceled.map(x => x.orders);
      chart.data.datasets[1].data = this.dailyOrdersData.success.map(x => x.orders);
      chart.data.datasets[2].data = this.dailyOrdersData.created.map(x => x.orders);
      chart.update()
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
